import { BrokerageJurisdictionRequestParams } from '@lio/api-types';

export const queryKeys = {
  jurisdictions: ['jurisdictions'] as const,
  brokerageJurisdictions: (params?: BrokerageJurisdictionRequestParams) => ['jurisdictions', params],
};
